import { render, staticRenderFns } from "./headPage.vue?vue&type=template&id=50eb7dfb&scoped=true&"
import script from "./headPage.vue?vue&type=script&lang=js&"
export * from "./headPage.vue?vue&type=script&lang=js&"
import style0 from "./headPage.vue?vue&type=style&index=0&id=50eb7dfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb7dfb",
  null
  
)

export default component.exports